<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="items" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                        @input="searching"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- /Filter -->
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="data"
                :loading="loading"
                :pagination="paginationConfig"
                row-key="customerid"
                @change="handleTableChange"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'customerid'">
                    <div class="productimgname">
                     
                      <router-link :to="{ path: '/customer-details', query: { id: record.customerid } }" title="View details">{{ record.customername }}</router-link>
                    </div></template
                  >

                  <template v-else-if="column.key === 'action'">
                    <router-link class="me-3" :to="{ path: '/customer-details', query: { id: record.customerid } }" title="View details">
                      <img src="../../../../assets/img/icons/eye.svg" alt="View" />
                    </router-link>
                    <template v-if="canEditCustomers || canDeleteCustomers">
                    <a v-if="canEditCustomers" class="me-3" @click="editcustomer(record)" href="javascript:void(0);">
                      <img src="../../../../assets/img/icons/edit.svg" alt="img" />
                    </a>
                    <a
                      v-if="canDeleteCustomers"
                      class="me-3 confirm-text"
                      href="javascript:void(0);"
                       @click="showAlert(record.customerid)"
                    >
                      <img src="../../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                    </template>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
  <custemerlistmodal></custemerlistmodal>
</template>
<script>
import axios from "axios";
const columns = [
  {
    sorter: true,
  },
  {
    title: "Customer Name",
    dataIndex: "customername",
    key: "customerid",
    sorter: {
      compare: (a, b) => {
        a = a.customername.toLowerCase();
        b = b.customername.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Mobile",
    dataIndex: "mobile",
    sorter: {
      compare: (a, b) => {
        a = (a.mobile || "").toLowerCase();
        b = (b.mobile || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Address",
    dataIndex: "address",
    sorter: {
      compare: (a, b) => {
        a = (a.address || "").toLowerCase();
        b = (b.address || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "GST No",
    dataIndex: "gstno",
    sorter: {
      compare: (a, b) => {
        a = (a.gstno || "").toLowerCase();
        b = (b.gstno || "").toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },

  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.post['Content-Type'] ='application/json;charset=utf-8';
axios.defaults.headers.common['api-key'] = process.env.VUE_APP_API_KEY;
const data = [
];
export default {
  data() {
    return {
      filter: false,
      search: '',
      searchTimer: null,
      loading: false,
      title: "Customer List",
      title1: "Manage your customers",
      data,
      columns,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    canAddCustomers() {
      return this.$store.getters.hasPermission('customer.add');
    },
    canEditCustomers() {
      return this.$store.getters.hasPermission('customer.edit');
    },
    canDeleteCustomers() {
      return this.$store.getters.hasPermission('customer.delete');
    },
    items() {
      return this.canAddCustomers
        ? [{ text: "Add Customer", addname: "/addcustomer" }]
        : [];
    },
    paginationConfig() {
      return {
        current: this.pagination.current,
        pageSize: this.pagination.pageSize,
        total: this.pagination.total,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} customers`,
      };
    },
  },
  methods: {
    handleKeydown(event) {
      if (
        this.canAddCustomers &&
        this.$route.path === '/customerlist' &&
        event.ctrlKey &&
        (event.key === 'm' || event.key === 'M')
      ) {
        event.preventDefault(); 
        
        this.$router.push('/addcustomer');
      }
    },
    searching() {
      if (this.search) this.filter = true;
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.pagination.current = 1;
        this.getItems();
      }, 300);
    },
    showAlert(id) {
      if (!this.canDeleteCustomers) {
        return;
      }
      // Use sweetalert2
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
          .delete('/v1/customers/'+id)
          .then(response => {
            Swal.fire("Deleted!", "Customer has been deleted.");
            this.getItems();
          })
          .catch(error => {
            console.log(error)
            Swal.fire(error.response.data.detail);
          });
          
        }
      });
    },
    editcustomer(customer) {
      if (!this.canEditCustomers) {
        return;
      }
      this.$router.push({ path: '/editcustomer', query: { id: customer.customerid } });
    },
    async getItems() {
      this.loading = true;
      axios
      .get('/v1/customers', {
        params: {
          page: this.pagination.current,
          page_size: this.pagination.pageSize,
          search: this.search.trim() || undefined,
        },
      })
      .then(response => {
        this.data = response.data.items || [];
        this.pagination = {
          current: response.data.page || this.pagination.current,
          pageSize: response.data.page_size || this.pagination.pageSize,
          total: response.data.total || 0,
        };
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => {
        this.loading = false;
      });
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getItems();
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
    clearTimeout(this.searchTimer);
  },
  beforeMount() {
    this.getItems();
  },
  name: "customerlist",
};
</script>
